import { useEffect } from "react";
import { tokenRefreshService } from "../services/tokenRefreshService";

export const useTokenRefresh = () => {
  useEffect(() => {
    tokenRefreshService.startAutoRefresh();

    return () => {
      tokenRefreshService.stopAutoRefresh();
    };
  }, []);

  return {
    refreshTokens: () => tokenRefreshService.refreshTokens(),
    isTokenValid: () => tokenRefreshService.isTokenValid(),
    getTimeUntilExpiry: () => tokenRefreshService.getTimeUntilExpiry(),
  };
};
